import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
  delay,
} from "redux-saga/effects";
import {
  ADD_USER,
  GET_NEW_COGNITO_USER,
  GET_NEW_COGNITO_SUCCESSFUL,
  GET_NEW_COGNITO_USER_FAILED,
  UPDATE_COGNITO_USER,
  DELETE_COGNITO_USER,
} from "./actionTypes";
import {
  addUserError,
  addUserSuccessfull,
  getUser as getUserAction,
  getUserSuccessful,
  getUserFailed,
  updateCognitoUserSuccessful,
  updateCognitoUserFailed,
  deleteCognitoUserSuccessful,
  deleteCognitoUserFailed,
} from "./actions";
import { addUser, getCognitoUser, deleteUser, updateUser } from "../../helpers/auth_helper";

function* addCognitoUser({ payload: {user} }){
    try {
        console.log("Add Cognito User :: ", user)
        const response = yield call(addUser, {
            firstname: user.firstname,
            lastname: user.lastname,
            username: user.email,
            password: user.password,
            groupname: user.groupName
        });
        console.log("Called")
        yield put(addUserSuccessfull(response));
        yield put(getUserAction());
    } catch (error) {
        console.log("Error is :: ", error.response.data)
        yield put(addUserError(error));
    }
}

function* getUser() {
    try {
        console.log("about to call *getUser()");
        const response = yield call(getCognitoUser);
        console.log("*getUser() response: ",  response);
        yield put(getUserSuccessful(response));
    } catch (error) {
        yield put(getUserFailed(error));
    }
}

//Added for update/delete cognito user

function* deleteCognitoUser({ payload: { username } }) {
  try {
    console.log("Delete Cognito User :: ", username);
    const response = yield call(deleteUser, {
      username: username,
    });
    console.log("Delete Cognito User API Called");
    yield put(deleteCognitoUserSuccessful(response));
    //Added the following to update the redux store, after delete is successful
    console.log("Calling getUser() from deleteCognitoUser saga...");
    yield delay(2000);
    yield put(getUserAction());

  } catch (error) {
    console.log("Delete Cognito User API Error is :: ", error);
    yield put(deleteCognitoUserFailed(error));
  }
}

function* updateCognitoUser({ payload: { user } }) {
        console.log(
          "saga -> updateCognitoUser called with",
          user
        );

  try {
    console.log("Update Cognito User :: ", user);
    // const response = yield call(updateUser, {
    //     firstName: user.firstName,
    //     lastName: user.lastName,
    //     username: user.username,
    //     groupname: user.groupname
    // });
    const response = yield call(updateUser, user);
    console.log("Update Cognito User API Called");
    yield put(updateCognitoUserSuccessful(user));
    //Added the following to update the redux store, after update is successful
    console.log("Calling getUser() from updateCognitoUser saga...");
    yield delay(2000);
    yield put(getUserAction());
  } catch (error) {
    console.log("Update Cognito User API Error is :: ", error);
    yield put(updateCognitoUserFailed(error));
  }
}


export function* watchCognitoUsers() {  
    yield takeLatest(ADD_USER, addCognitoUser);
    yield takeLatest(DELETE_COGNITO_USER, deleteCognitoUser);
    yield takeLatest(UPDATE_COGNITO_USER, updateCognitoUser);    
    yield takeLatest(GET_NEW_COGNITO_USER, getUser);
}

// export function* watchGetCognitoUsers() {  
//     yield takeLatest(GET_NEW_COGNITO_USER, getUser);
// }

// export function* watchAddCognitoUser() {
//     yield takeLatest(ADD_USER, addCognitoUser);
// }

// export function* watchDeleteCognitoUser() {
//   yield takeLatest(DELETE_COGNITO_USER, deleteCognitoUser);
// }

// export function* watchUpdateCognitoUser() {
//   yield takeLatest(UPDATE_COGNITO_USER, updateCognitoUser);    
// }

// function* cognitoUserSaga() {
//     yield all([
//         fork(watchGetCognitoUsers),
//         fork(watchAddCognitoUser),
//         fork(watchDeleteCognitoUser),
//         fork(watchUpdateCognitoUser),
//     ]);
// }

function* cognitoUserSaga() {
  yield all([
    fork(watchCognitoUsers),
  ]);
}

export default cognitoUserSaga;